/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ThreadSummary } from './ThreadSummary';
import {
    ThreadSummaryFromJSON,
    ThreadSummaryFromJSONTyped,
    ThreadSummaryToJSON,
    ThreadSummaryToJSONTyped,
} from './ThreadSummary';

/**
 * 
 * @export
 * @interface PaginatedThreadsResponse
 */
export interface PaginatedThreadsResponse {
    /**
     * 
     * @type {number}
     * @memberof PaginatedThreadsResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedThreadsResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedThreadsResponse
     */
    limit: number;
    /**
     * 
     * @type {Array<ThreadSummary>}
     * @memberof PaginatedThreadsResponse
     */
    threads: Array<ThreadSummary>;
}

/**
 * Check if a given object implements the PaginatedThreadsResponse interface.
 */
export function instanceOfPaginatedThreadsResponse(value: object): value is PaginatedThreadsResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('threads' in value) || value['threads'] === undefined) return false;
    return true;
}

export function PaginatedThreadsResponseFromJSON(json: any): PaginatedThreadsResponse {
    return PaginatedThreadsResponseFromJSONTyped(json, false);
}

export function PaginatedThreadsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedThreadsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'threads': ((json['threads'] as Array<any>).map(ThreadSummaryFromJSON)),
    };
}

export function PaginatedThreadsResponseToJSON(json: any): PaginatedThreadsResponse {
    return PaginatedThreadsResponseToJSONTyped(json, false);
}

export function PaginatedThreadsResponseToJSONTyped(value?: PaginatedThreadsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'threads': ((value['threads'] as Array<any>).map(ThreadSummaryToJSON)),
    };
}

